const initialState = {
	loading: false,
	account: null,
	smartContract: null,
	web3: null,
	errorMsg: 'Please connect wallet',
};

const blockchainReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'CONNECTION_REQUEST':
			return {
				...initialState,
				loading: true,
				errorMsg: action.payload,
			};
		case 'CONNECTION_SUCCESS':
			return {
				...state,
				loading: false,
				account: action.payload.account,
				// smartContract: action.payload.smartContract,
				provider: action.payload.provider,
				signer: action.payload.signer,
			};
		case 'CONNECTION_FAILED':
			return {
				...initialState,
				loading: false,
				errorMsg: action.payload,
			};
		case 'UPDATE_ACCOUNT':
			return {
				...state,
				account: action.payload.account,
			};
		default:
			return state;
	}
};

export default blockchainReducer;
